<div class="form form--date-short form--full-width" [ngClass]="getLevelClass()">
  <div class="form__label">
    <basic-label></basic-label>
  </div>
  <div class="form__field">
    <basic-text-input
      [propertyName]="questionItem.prop"
      [hideLabel]="true"
      [placeholder]="'mm/yyyy'"
      [parserType]="'ShortDate'"
      [formatterType]="'date_mmyyyy'"
      [inputMask]="mask"
    ></basic-text-input>
  </div>
</div>
